import { render, staticRenderFns } from "./TableBase1110.vue?vue&type=template&id=13f928bf&scoped=true&lang=pug&"
import script from "./TableBase1110.vue?vue&type=script&lang=ts&"
export * from "./TableBase1110.vue?vue&type=script&lang=ts&"
import style0 from "./TableBase1110.vue?vue&type=style&index=0&id=13f928bf&lang=stylus&scoped=true&"
import style1 from "./TableBase1110.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f928bf",
  null
  
)

export default component.exports